import { Sites } from '@ps/platform-message-framework/common/Sites';
import { select } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import useWizardExit from '@swf/core/hooks/useWizardExit';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import useRmfLogout from '../../hooks/useRmfLogout';

import {
  TXTWCL_Close,
  TXTWCL_Thank_You,
  TXTWCL_Your_details_have_been_savedX
} from './RMFStandaloneFinalPage.messages.json';

const RMFStandaloneFinalPage: React.FC = () => {
  const isEmbedded = useSelector(select.device.isEmbedded);
  const exitWizard = useWizardExit();
  const site = useSelector(select.cms.getSiteId);
  const isUK = site === Sites.UK;
  const logout = useRmfLogout();

  const handleButtonClick = () => {
    if (isEmbedded) {
      window.starsweb?.app?.execute('close-rmf/completed');
      isUK && window.starsweb?.app?.execute('close-rmf/logout');
      postMessage('close');
      window.close();
    } else {
      exitWizard();
      isUK && logout?.();
    }
  };

  return (
    <Container
      page={RMFStandaloneFinalPage}
      headerProps={{ title: <Translation {...TXTWCL_Thank_You} />, buttons: {} }}
      pageTopTitle={<Translation {...TXTWCL_Thank_You} />}
    >
      <Translation tagName="p" {...TXTWCL_Your_details_have_been_savedX} />
      <CTAButton translation={TXTWCL_Close} onClick={handleButtonClick} />
    </Container>
  );
};

RMFStandaloneFinalPage.displayName = 'RMFStandaloneFinalPage';

export default RMFStandaloneFinalPage;
